import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ACTOR_PROFILE_BASE_ROUTE } from 'src/navigation';
import { UserContactInformation } from '../user-contact-info';

const ActorProfile = React.lazy(() => import('./pages/ActorProfile'));
const EditActor = React.lazy(() => import('./pages/EditActor'));

const ActorProfileEmailSettings = React.lazy(() => import('./pages/ActorProfileEmailSettings'));
const ActorProfileAccessControlSettings = React.lazy(
  () => import('./pages/ActorProfileAccessControlSettings'),
);
const ActorProfileEdit = React.lazy(() => import('./pages/ActorProfileSettings'));

const ACTOR_PROFILE_SETTINGS = 'settings';
const ACTOR_PROFILE_GENERAL_INFO = 'actor-profile';
const ACTOR_PROFILE_CONTACT_INFO = 'contact-information';
const ACTOR_PROFILE_EMAIL_SETTINGS = 'email';
const ACTOR_PROFILE_ACCESS_CONTROL = 'access';

export const ACTOR_PROFILE = {
  BASE: ACTOR_PROFILE_BASE_ROUTE,
  SETTINGS: {
    BASE: `${ACTOR_PROFILE_BASE_ROUTE}/${ACTOR_PROFILE_SETTINGS}`,
    CONTACT_INFORMATION: `${ACTOR_PROFILE_BASE_ROUTE}/${ACTOR_PROFILE_SETTINGS}/${ACTOR_PROFILE_CONTACT_INFO}`,
    ACCESS_CONTROL: `${ACTOR_PROFILE_BASE_ROUTE}/${ACTOR_PROFILE_SETTINGS}/${ACTOR_PROFILE_ACCESS_CONTROL}`,
    EMAIL: `${ACTOR_PROFILE_BASE_ROUTE}/${ACTOR_PROFILE_SETTINGS}/${ACTOR_PROFILE_EMAIL_SETTINGS}`,
    GENERAL_INFO: `${ACTOR_PROFILE_BASE_ROUTE}/${ACTOR_PROFILE_SETTINGS}/${ACTOR_PROFILE_GENERAL_INFO}`,
  },
} as const;

const routes: RouteObject[] = [
  {
    path: '',
    index: true,
    element: <ActorProfile />,
  },
  {
    path: ':actorId',
    element: <ActorProfile />,
  },
  {
    path: ACTOR_PROFILE_SETTINGS,
    element: <ActorProfileEdit />,
    children: [
      {
        path: ACTOR_PROFILE_CONTACT_INFO,
        element: <UserContactInformation />,
      },
      {
        path: ACTOR_PROFILE_ACCESS_CONTROL,
        element: <ActorProfileAccessControlSettings />,
      },
      {
        path: ACTOR_PROFILE_EMAIL_SETTINGS,
        element: <ActorProfileEmailSettings />,
      },
      {
        path: ACTOR_PROFILE_GENERAL_INFO,
        element: <EditActor />,
      },
    ],
  },
];

export default routes;
